export const translateStatus = (task) => {
  switch (task?.status) {
    case 'complete':
      return 'Completed';
    case 'archived':
      return 'Archived';
    case 'overdue':
      return 'Overdue';
    case 'to_do':
      return 'To Do';
    default:
      return task?.status ?? '—';
  }
};

export const getBadgeColor = (task) => {
  switch (task?.status) {
    case 'overdue':
      return '#D0021B';
    case 'to_do':
      return '#4467AB';
    case 'complete':
      return '#E7F3E5';
    case 'archived':
    default:
      return '#C7D8E8';
  }
};

export const getTextColor = (task) => {
  switch (task?.status) {
    case 'overdue':
    case 'to_do':
      return 'white';
    default:
      return '#182A44';
  }
};
